<agpr-take-over-panel
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close()"
    [responsiveWidth]="true"
    [minPanelWidth]="minPanelWidth"
    [maxPanelWidth]="maxPanelWidth"
    [header]="'Discover.aeoRecommendationsDialog.header'"
>
    <div class="agpr-aeoRecommendations">
        @if (loading || recommendations.length > 0) {
            <div
                class="agpr-aeoRecommendations-left"
                [ngClass]="{'agpr-aeoRecommendations-recommendations--loading': loading}"
            >
                <h2 class="agpr-aeoRecommendations-header">{{ 'Discover.aeoRecommendationsDialog.recommendations' | localize }}</h2>
                <div class="agpr-aeoRecommendations-subHeader">{{ 'Discover.aeoRecommendationsDialog.recommendations.description' | localize }}</div>
                <agpr-scroll-panel>
                    <div
                        class="agpr-aeoRecommendations-recommendations"
                    >
                        @if (loading) {
                            <div class="loading-placeholder loading-placeholder-opacity8">
                                <div class="loading-placeholder-skeleton2"></div>
                            </div>
                            <div class="loading-placeholder loading-placeholder-opacity5">
                                <div class="loading-placeholder-skeleton1"></div>
                            </div>
                            <div class="loading-placeholder loading-placeholder-opacity3">
                                <div class="loading-placeholder-skeleton2"></div>
                            </div>
                            <div class="loading-placeholder loading-placeholder-opacity1">
                                <div class="loading-placeholder-skeleton1"></div>
                            </div>
                        } @else {
                            @for (recommendation of recommendations; track recommendation; let i = $index) {
                                <button
                                    class="recommendation"
                                    [ngClass]="{'recommendation--selected': selectedRecommendation == recommendation}"
                                    (click)="selectedRecommendation = recommendation;"
                                >
                                    <div class="recommendation-selectedBar"></div>
                                    <div class="recommendation-content">
                                        <h3 class="recommendation-header">{{ recommendation.title }}</h3>
                                        <div class="recommendation-description">{{ recommendation.briefRationale }}</div>
                                    </div>
                                </button>
                            }

                        }

                    </div>
                </agpr-scroll-panel>
            </div>
            <div class="agpr-aeoRecommendations-right">
                @if (loading) {
                    <div class="agpr-aeoRecommendations-right-loading">
                        <span [agprLoading]="loading" [agprInlineLoadingIndicator]="true" [loadingSmallIndicator]="true"></span>
                        <h2 class="agpr-aeoRecommendations-header">{{ 'Discover.aeoRecommendationsDialog.reasoning' | localize }}</h2>
                    </div>
                    <div class="agpr-aeoRecommendations-right-loading-subheading">{{ 'Discover.aeoRecommendationsDialog.loading.title' | localize }}</div>
                    <div class="agpr-aeoRecommendations-right-loading-text">{{ 'Discover.aeoRecommendationsDialog.loading.text' | localize }}</div>
                } @else if (selectedRecommendation){
                    <h2 class="agpr-aeoRecommendations-header">{{ selectedRecommendation.title }}</h2>
                    <div class="agpr-aeoRecommendations-subHeader">{{ selectedRecommendation.extendedRationale }}</div>
                    <div class="agpr-aeoRecommendations-example">
                        <div class="agpr-aeoRecommendations-example-heading">
                            <h3>{{ 'Discover.aeoRecommendationsDialog.example' | localize }}</h3>
                            <agpr-button
                                [style]="buttonTypes.icon"
                                icon="fa-kit-duotone fa-agpr-copy"
                                tooltip="Core.button.copy"
                                tooltipPosition="left"
                                (click)="copyGeneratedContent()"
                            ></agpr-button>
                        </div>
                        <div class="agpr-aeoRecommendations-example-content" [innerHtml]="selectedRecommendation.example"></div>
                    </div>
                }


            </div>
        } @else {
            <div class="agpr-aeoRecommendations-noContent">
                <agpr-message
                    [severity]="messageSeverityEnum.noContent"
                >
                    <h2>{{ 'Discover.aeoRecommendationsDialog.noContent.header' | localize }}</h2>
                    {{ 'Discover.aeoRecommendationsDialog.noContent.message' | localize }}
                </agpr-message>
            </div>

        }

    </div>
    <ng-template #takeOverFooterRight>
        <agpr-button
            label="done"
            [style]="buttonTypes.primary"
            (click)="close()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>